import ResultTable from '../../components/table/ResultTable';
import ResultHeader from '../../components/table/ResultHeader';
import ResultRow from '../../components/table/ResultRow';
import ResultHeaderCell from '../../components/table/ResultHeaderCell';
import HecRasHelper from '../../helpers/HecRasHelper';
import ResultBody from '../../components/table/ResultBody';
import ResultBodyCell from '../../components/table/ResultBodyCell';

export default function BoundaryTable({ data }) {
    return (
        <ResultTable maxWidth={HecRasHelper.getWidth(40)}>
            <ResultHeader>
                <ResultRow>
                    <ResultHeaderCell
                        style={{
                            textAlign: 'start',
                            width: HecRasHelper.getWidth(5),
                        }}
                    >
                        Profile
                    </ResultHeaderCell>
                    <ResultHeaderCell
                        style={{
                            textAlign: 'start',
                            width: HecRasHelper.getWidth(12),
                        }}
                    >
                        Downstream BC
                    </ResultHeaderCell>
                </ResultRow>
            </ResultHeader>
            <ResultBody>
                {data?.map((row, idx) => {
                    return (
                        <ResultRow>
                            <ResultBodyCell
                                style={{
                                    textAlign: 'start',
                                    width: HecRasHelper.getWidth(10),
                                }}
                            >
                                {row?.profile}
                            </ResultBodyCell>
                            <ResultBodyCell
                                style={{
                                    textAlign: 'start',
                                    width: HecRasHelper.getWidth(30),
                                }}
                            >
                                {row?.name} = {row?.value}
                            </ResultBodyCell>
                        </ResultRow>
                    );
                })}
            </ResultBody>
        </ResultTable>
    );
}
